import { useState } from "react";
import { Box, Button, Link, Typography } from "@mui/material";
import { analyticsConsent, setAnalyticsConsent } from "@/shared/analytics/ga4";
import { marketingLiftSx } from "@/shared/theme";

export const AnalyticsConsent = () => {
  const [choice, setChoice] = useState(() => analyticsConsent());
  if (choice) return null;

  const choose = (value: "granted" | "denied") => {
    setAnalyticsConsent(value);
    setChoice(value);
  };

  const marketingUrl = import.meta.env.VITE_MARKETING_URL ?? "https://chessla.net";
  return (
    <Box
      role="dialog"
      aria-label="Analytics choice"
      sx={{
        position: "fixed",
        zIndex: 1600,
        left: { xs: 12, md: 24 },
        right: { xs: 12, md: "auto" },
        top: { xs: 64, md: "auto" },
        bottom: { xs: "auto", md: 24 },
        maxWidth: 430,
        p: { xs: 2, md: 2.5 },
        border: "2px solid #ff3d00",
        bgcolor: "#0a0a0a",
        color: "#f0ece2",
        boxShadow: "8px 8px 0 rgba(255,61,0,.28)",
      }}
    >
      <Typography sx={{ color: "#ff3d00", fontSize: ".62rem", fontWeight: 950, letterSpacing: ".14em" }}>
        CHESSLA / OPTIONAL ANALYTICS
      </Typography>
      <Typography sx={{ mt: 1.2, fontSize: "1.05rem", fontWeight: 950, letterSpacing: "-.025em" }}>
        Help Chessla learn what helps.
      </Typography>
      <Typography sx={{ mt: 0.7, color: "#c8c2b7", fontSize: ".73rem", lineHeight: 1.6 }}>
        With your permission, we measure anonymous product events. We never send your name, email, games, moves, or
        Nikola’s words.
      </Typography>
      <Typography sx={{ mt: 1, color: "#c8c2b7", fontSize: ".65rem" }}>
        Read our{" "}
        <Link
          href={`${marketingUrl}/privacy`}
          target="_blank"
          rel="noreferrer"
          sx={{ color: "#f0ece2", fontWeight: 900 }}
        >
          PRIVACY
        </Link>{" "}
        and{" "}
        <Link
          href={`${marketingUrl}/terms`}
          target="_blank"
          rel="noreferrer"
          sx={{ color: "#f0ece2", fontWeight: 900 }}
        >
          TERMS
        </Link>
        .
      </Typography>
      <Box sx={{ mt: 2, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 1 }}>
        <Button
          onClick={() => choose("granted")}
          sx={{
            minHeight: 44,
            border: "1px solid #ff3d00",
            borderRadius: 0,
            bgcolor: "#ff3d00",
            color: "#0a0a0a",
            fontSize: ".67rem",
            fontWeight: 950,
            ...marketingLiftSx("#f0ece2"),
            "&:hover, &:focus-visible": {
              ...marketingLiftSx("#f0ece2")["&:hover, &:focus-visible"],
              bgcolor: "#ff3d00",
            },
          }}
        >
          ALLOW ANALYTICS
        </Button>
        <Button
          onClick={() => choose("denied")}
          sx={{
            minHeight: 44,
            border: "1px solid #f0ece2",
            borderRadius: 0,
            color: "#f0ece2",
            fontSize: ".67rem",
            fontWeight: 950,
            "&:hover": { bgcolor: "#f0ece2", color: "#0a0a0a" },
          }}
        >
          NO THANKS
        </Button>
      </Box>
    </Box>
  );
};
